import { TEMPLATE_BUILD_SLUG } from 'src/js/constants/common';

const getTemplateBuildSlug = () => {
  const parsedUrl = new URL(window.location.href);
  return parsedUrl.searchParams.get(TEMPLATE_BUILD_SLUG);
};

export default getTemplateBuildSlug;
